import WillReceive from "@/components/layout/matching-bonus/WillReceive";
import ErrorMatchingBonus from "@/components/layout/modal/ErrorMatchingBonus";
import SuccessfulMatchingBonus from "@/components/layout/modal/SuccessfulMatchingBonus";
import ConnectedWallet from "@/components/layout/settings/ConnectedWallet";
import { useMatchingBonusValueStore } from "@/modules/matching-bonus/store/value";
import {
  useModalSuccessfulMatchingBonusStore,
} from "@/shared/store/modal";
import { useEffect } from "react";

const MatchingBonus = () => {
  const { currentToken, setCurrentToken, setNet } = useMatchingBonusValueStore();
  const { isOpen, isOpenError, closeModal } =
    useModalSuccessfulMatchingBonusStore();

  useEffect(() => {
    setNet("ton");
    if (currentToken === "ton") {
      setCurrentToken("");
    }
  }, [currentToken, setCurrentToken, setNet]);

  return (
    <>
      <div className="flex flex-col justify-between items-center gap-3 px-4 pb-40">
        <ConnectedWallet />

        <WillReceive />
      </div>

      {isOpen && <SuccessfulMatchingBonus onClose={closeModal} />}

      {isOpenError && <ErrorMatchingBonus />}
    </>
  );
};

export default MatchingBonus;
